<template>
  <div style="height: calc(100vh - 160px)">
    <div class="filter-box">
      <div class="form-box">
        <a-select placeholder="任务状态" mode="tags" style="width: 200px; margin-right: 10px" v-model="exportAsyncTaskTable.queryParams.taskStatusList">
          <a-select-option v-for="option in exportAsyncTaskTable.helper.taskStatusOptions" :key="option.value">
            {{ option.label }}
          </a-select-option>
        </a-select>
        <a-date-picker
          placeholder="创建时间从"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          show-time
          style="width: 200px; margin-right: 10px"
          v-model="exportAsyncTaskTable.queryParams.createTimeFrom"
        />
        <a-date-picker
          placeholder="创建时间至"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          show-time
          style="width: 200px; margin-right: 10px"
          v-model="exportAsyncTaskTable.queryParams.createTimeTo"
        />
      </div>
      <div class="button-box">
        <a-button class="filter_box_button" @click="resetExportAsyncTaskQuertParams">重置</a-button>
        <a-button class="filter_box_button" type="primary" @click="searchExportAsyncTask">搜索</a-button>
        <a-button class="filter_box_button" @click="exportAsyncTaskTable.view.modalVisable = true">导出</a-button>
      </div>
    </div>
    <div style="height: calc(100% - 100px)">
      <vxe-table
        height="auto"
        :border="true"
        :row-config="{ isHover: true }"
        :data="exportAsyncTaskTable.pageResponse.currentList"
        :loading="exportAsyncTaskTable.view.loading"
      >
        <vxe-column field="id" title="任务编号" width="100"></vxe-column>
        <vxe-column field="createTime" title="创建时间" width="200"></vxe-column>
        <vxe-column field="taskFunc" title="任务功能" width="150" show-overflow="tooltip"></vxe-column>
        <vxe-column field="taskProgress" title="任务进度" width="150">
          <template #default="{ row }">
            <a-progress :percent="row.taskProgress" :status="adaptProgressStatus(row.taskStatus)" />
          </template>
        </vxe-column>
        <vxe-column field="exportFileSize" title="导出文件大小" width="150">
          <template #default="{ row }">
            {{ adaptFileSize(row.exportFileSize) }}
          </template>
        </vxe-column>
        <vxe-column field="exportFileName" title="导出文件名称" width="150" show-overflow="tooltip"></vxe-column>
        <vxe-column field="exportFilePath" title="导出文件路径" show-overflow="tooltip"></vxe-column>
        <vxe-column title="下载" width="100">
          <template #default="{ row }">
            <a-button :disabled="row.taskStatus !== 'completed'" @click="downloadExportAsyncTaskFileById(row.id)">下载</a-button>
          </template>
        </vxe-column>
      </vxe-table>
      <a-pagination
        size="small"
        :total="exportAsyncTaskTable.pageResponse.totalSize"
        :show-total="exportAsyncTaskTable.view.showTotal"
        @change="onExportAsyncTaskTablePageChange"
        style="margin-top: 20px; float: right"
      />
    </div>
    <a-modal v-model="exportAsyncTaskTable.view.modalVisable" title="导出" @ok="submitExportAsyncTask" @cancel="resetExportParams">
      <a-form-model :model="exportAsyncTaskTable.exportParams" layout="horizontal" label-align="left" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="导出文件名称">
          <a-input v-model="exportAsyncTaskTable.exportParams.exportFileName"></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import * as exportAsyncTaskApi from '@/api/export_async_task.js'
import * as paramUtil from '@/utils/param'

export default {
  name: 'ExportAsyncTask',
  data() {
    return {
      exportAsyncTaskTable: {
        pageRequest: {
          pageSize: 20,
          currentPage: 1
        },
        pageResponse: {
          totalSize: 0,
          totalPage: 0,
          currentList: []
        },
        queryParams: {
          taskStatusList: ['completed'],
          createTimeFrom: '',
          createTimeTo: ''
        },
        exportParams: {
          exportFileName: '异步导出任务.xlsx'
        },
        helper: {
          taskStatusOptions: [
            { value: 'pending', label: '已创建' },
            { value: 'processing', label: '处理中' },
            { value: 'completed', label: '已完成' },
            { value: 'failed', label: '已失败' }
          ]
        },
        view: {
          modalVisable: false,
          loading: true,
          showTotal: total => `共 ${total} 条`
        }
      }
    }
  },
  created() {},
  mounted() {
    this.searchExportAsyncTask()
  },
  methods: {
    searchExportAsyncTask() {
      this.exportAsyncTaskTable.view.loading = true
      exportAsyncTaskApi
        .findExportAsyncTask({
          ...paramUtil.simplifyQuery(this.exportAsyncTaskTable.queryParams),
          ...this.exportAsyncTaskTable.pageRequest
        })
        .then(body => {
          this.exportAsyncTaskTable.view.loading = false
          this.exportAsyncTaskTable.pageResponse = body.data
        })
    },

    downloadExportAsyncTaskFileById(id) {
      exportAsyncTaskApi.downloadExportAsyncTaskFileById(id).then(({ blob, filename }) => {
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.href = url
        link.download = filename
        link.click()
        URL.revokeObjectURL(url)
      })
    },

    submitExportAsyncTask() {
      return exportAsyncTaskApi
        .exportExportAsyncTask({
          ...paramUtil.simplifyQuery(this.exportAsyncTaskTable.queryParams),
          ...this.exportAsyncTaskTable.exportParams
        })
        .then(({ blob, filename }) => {
          const link = document.createElement('a')
          const url = URL.createObjectURL(blob)
          link.href = url
          link.download = filename
          link.click()
          URL.revokeObjectURL(url)
          this.exportAsyncTaskTable.view.modalVisable = false
          this.resetExportParams()
        })
    },

    resetExportAsyncTaskQuertParams() {
      this.exportAsyncTaskTable.queryParams = {
        taskStatusList: [],
        createTimeFrom: '',
        createTimeTo: ''
      }
    },

    resetExportParams() {
      this.exportAsyncTaskTable.exportParams = {
        exportFileName: '异步导出任务.xlsx'
      }
    },

    onExportAsyncTaskTablePageChange(currentPage, pageSize) {
      this.exportAsyncTaskTable.pageRequest = { currentPage, pageSize }
      this.searchExportAsyncTask()
    },

    adaptFileSize(byteSize) {
      if (byteSize === 0) {
        return '0B'
      }
      const units = ['B', 'KB', 'MB', 'GB', 'TB']
      const base = 1024
      const index = Math.floor(Math.log(byteSize) / Math.log(base))
      const size = (byteSize / Math.pow(base, index)).toFixed(1)
      return `${size}${units[index]}`
    },

    adaptProgressStatus(taskStatus) {
      const map = {
        pending: 'normal',
        processing: 'active',
        completed: 'success',
        failed: 'exception'
      }
      return map[taskStatus]
    }
  }
}
</script>

<style scoped>
.filter-box {
  margin-bottom: 20px;
}

.form-box {
  width: calc(100% - 225px);
  display: inline-block;
}

.button-box {
  width: 225px;
  display: inline-block;
  vertical-align: top;
}

.filter_box_button {
  margin-left: 10px;
}
</style>
